
import QDate from 'quasar/src/components/date/QDate.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';;
import { defineComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';

export default defineComponent({
	name: 'date-input',

	props: {
		autofocus: {
			type: Boolean,
			default: false
		},
		message: {
			type: Object as PropType<Message> | null,
			default: null
		}
	},

	emits: ['input-value'],

	components: {
		QDate,
		QPopupProxy
	},

	data() {
		return {
			date: '',
			proxyDate: '', // Дата, которую мы выбрали в модалке, но не подтвердили
			validationFormat: ''
		};
	},

	mounted() {
		if (this.message?.validation?.format) {
			this.validationFormat = this.message.validation.format;
		}
	},

	methods: {
		inputValue() {
			if (!this.date) return;
			this.$emit('input-value', this.date);
			this.date = '';
		},

		save() {
			this.date = this.proxyDate;
		},

		updateProxy() {
			this.proxyDate = this.date;
		}
	}
});
